import http from "../../../services/httpService";
import { injectHtml, injectHtmlIntoEntity } from "../../../utils/htmlUtil";
import { error, isEmpty, initToggleIconRotate, rotateElement } from "../../common/global";

const props = {
    contactUsMarker: '#m-contact-us-form',
    categoryButton: '.contact-us-category',
    contentItemHeader: '.contact-us-accordion-header',
    contentItemAccordionContent: '.contact-us-accordion-content'

};

export function initContactUs() {

    if ($(props.contactUsMarker).length) {
        initContactUsSelfService();
    }
}

async function initContactUsSelfService() {

    $(props.categoryButton).off("click").on('click', async function () {

        //category button clicked; load next level of data, rebind all events
        loadSelectedCategory($(this));
    });

    initToggleIconRotate();

    //NOTE: we are deliberately NOT using .off("click") on the next event reg as the reg of initToggleIconRotate already does this for $(props.contentItemHeader)
    //if we do it again it'll undo the binding for initToggleIconRotate, which has already reset all click events for this set of objects

    //initialises 'accordion' elements for any relevant items currently display
    $(props.contentItemHeader).on('click', function (e) {
        toggleContentItemHeader($(this));
    });
}

async function toggleContentItemHeader(headerSelected) {

    var selectedHeaderParentItem = headerSelected.closest('.contact-us-accordion-item');

    var linkedAccordionItem = selectedHeaderParentItem.find(props.contentItemAccordionContent);

    var itemIsExtended = linkedAccordionItem.is(':visible');

    //if open, just close all.
    $(props.contentItemAccordionContent).slideUp(300, function () {

        //identify all rotated icons, except for one that is to be opened, then remove rotate-45 class. this returns the icon to it's correct initial orientation
        var rotatedIcons = $('.rotate-45');

        rotatedIcons.each(function (index, value) {

            var parentHeader = $(this).closest(props.contentItemHeader);

            if (parentHeader.data('id') !== headerSelected.data('id')) {
                $(this).removeClass('rotate-45');
            }
        });

        //NOTE: timeout is used here as the 'slideUp(300, function () {' doesn't always work as intended and sometimes the slide up / down events are registered too early.
        //this results in a 'double slide' which looks poor. slightly longer timeout outside of this fixes the issue

        setTimeout(function () {

            //if item clicked is closed, close all then open this
            if (!itemIsExtended) {
                linkedAccordionItem.slideDown(300);
            }
        }, 350);        
    });
}

async function loadSelectedCategory(buttonSelected) {

    //find 'child' wrapper for this item
    var parentWrapper = buttonSelected.closest('.contact-us-level-wrapper');

    var allButtons = parentWrapper.find(props.categoryButton);

    allButtons.removeClass('category-selected');

    buttonSelected.addClass('category-selected');

    var childItemsWrapper = parentWrapper.find('.child-contact-us-level-wrapper');

    //slide up this element. clear contents.
    childItemsWrapper.slideUp(300, async function () {

        //call service to get html to replace current data
        const data = { parentCategoryId: buttonSelected.data('id') };

        const result = await getCategoryChildItemViewService(data);

        await injectHtmlIntoEntity(childItemsWrapper, result);

        //display on load (slide down) 
        childItemsWrapper.slideDown(300, function () {

            //rebind events
            initContactUsSelfService();

            $('#contact-form-wrapper').slideDown(300);
        });
    });

    //blur the button to prevent the 'focus' styling from being shown. creates an adequate tone change, too.
    buttonSelected.blur();
}


//API CALLS
async function getCategoryChildItemViewService(data) {

    //no TRY CATCH as handled by parent
    //returns result as html
    const response = await http.get('/support/getcontactuslevel', data);

    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}
